import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaCloudUploadAlt, FaTrash } from 'react-icons/fa';

import { getImageUrl } from '../utils/imageUtils';

const UploaderContainer = styled.div`
  border: 2px dashed ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s;
  background: #fafafa;

  &:hover {
    border-color: ${({ theme }) => theme.colors.secondary};
  }
`;

const PreviewContainer = styled.div`
  position: relative;
  margin-top: 1rem;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
`;

const PreviewImage = styled.img`
  width: 100%;
  border-radius: 4px;
  display: block;
`;

const RemoveButton = styled.button`
  position: absolute;
  top: -10px;
  right: -10px;
  background: ${({ theme }) => theme.colors.danger};
  color: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
`;

const HiddenInput = styled.input`
  display: none;
`;

const ImageUploader = ({ onImageSelect, previewUrl: initialPreview, multiple = false }) => {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(initialPreview);

  useEffect(() => {
    console.log('ImageUploader preview updated:', initialPreview);
    setPreview(initialPreview);
  }, [initialPreview]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    if (multiple) {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            // For multiple files, we don't show a single preview inside this component 
            // unless we want to implement a carousel, but usually parent handles it.
            // We'll just pass the files up.
            onImageSelect(files);
        }
    } else {
        const file = e.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            console.log('ImageUploader local preview:', url);
            setPreview(url);
            onImageSelect(file);
        }
    }
    // Reset input so same file can be selected again if needed
    e.target.value = ''; 
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setPreview(null);
    onImageSelect(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <div>
        {!preview || multiple ? (
            <UploaderContainer onClick={handleClick}>
                <FaCloudUploadAlt size={40} color="#ccc" />
                <p>{multiple ? 'Click to upload images' : 'Click to upload image'}</p>
                <HiddenInput 
                    type="file" 
                    accept="image/*" 
                    multiple={multiple}
                    ref={fileInputRef} 
                    onChange={handleChange} 
                />
            </UploaderContainer>
        ) : (
            <PreviewContainer>
                <PreviewImage 
                    src={getImageUrl(preview)} 
                    alt="Preview" 
                    onError={(e) => console.error('Image load error for src:', e.target.src, e)}
                />
                <RemoveButton type="button" onClick={handleRemove}>
                    <FaTrash size={14} />
                </RemoveButton>
            </PreviewContainer>
        )}
    </div>
  );
};

export default ImageUploader;
